import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Drawer, Button } from 'antd';
import IntlMessages from '../../../../util/IntlMessages';
import CustomScrollbars from '../../../../util/CustomScrollbars';
import { useHistory } from 'react-router-dom';
import FetchBpmNewCaseIframe from '../../../../components/FetchData/FetchBpmNewCaseIframe';

const NewCase = () => {
  const history = useHistory();
  const [drawerState, setDrawerState] = useState(false);
  const [addNewReminder, setAddNewReminder] = useState(false);

  const getNavFilters = () => {
    return <li>Nothing</li>;
  };
  const ToDoSideBar = () => {
    return (
      drawerState && (
        <div className="gx-module-side">
          <div className="gx-module-side-header">
            <div className="gx-module-logo">
              <i className="icon icon-check-circle-o gx-mr-4" />
              <IntlMessages id="sidebar.todoApp" />
            </div>
          </div>
          <div className="gx-module-side-content">
            <CustomScrollbars className="gx-module-side-scroll">
              <div className="gx-module-add-task">
                <Button
                  type="primary"
                  className="gx-btn-block"
                  onClick={() => {
                    setAddNewReminder(!addNewReminder);
                    setDrawerState(false);
                  }}
                >
                  <IntlMessages id="todo.addTask" />
                </Button>
              </div>
              <ul className="gx-module-nav">{getNavFilters()}</ul>
            </CustomScrollbars>
          </div>
        </div>
      )
    );
  };
  const onToggleDrawer = () => {
    setDrawerState(!drawerState);
  };

  const { bpmNewCaseUrl } = useSelector(({ bpm }: any) => bpm);

  return (
    //   <div>
    //       {bpmNewCaseUrl !== '' ?
    //                     <FetchBpmIframe src={`${bpmNewCaseUrl}`} />
    //                     :
    //                     <div style={{marginTop: "4rem"}} className="gx-d-flex gx-flex-row gx-justify-content-center gx-align-items-center gx-w-100">
    //                         <i style={{ color: '#c3c3c3' }} className="icon icon-extra-components gx-fs-80" />
    //                         <div className="gx-d-flex gx-flex-row gx-justify-content-center gx-align-items-center gx-w-100">
    //                             <span className="gx-text-grey gx-font-weight-bold" >آدرسی وجود ندارد</span>
    //                         </div>
    //                     </div>
    //                 }
    //   </div>
    <div className="gx-main-content">
      <div className="gx-app-module">
        <div className="gx-d-block gx-d-lg-none">
          <Drawer
            placement="right"
            closable={false}
            visible={drawerState}
            onClose={onToggleDrawer.bind}
          >
            {ToDoSideBar()}
          </Drawer>
        </div>
        <div className="gx-module-sidenav gx-d-none gx-d-lg-flex">
          {ToDoSideBar()}
        </div>

        <div className="gx-module-box">
          <div className="gx-module-box-header">
            <div className="gx-d-flex gx-align-items-center gx-position-absolute gx-left-0">
              <i
                className="icon icon-arrow-left gx-icon-btn"
                onClick={() => {
                  history.goBack();
                }}
              />
            </div>
            {/* <span className="gx-drawer-btn gx-d-flex gx-d-lg-none">
                      <i
                          className="icon icon-menu gx-icon-btn"
                          aria-label="Menu"
                          onClick={onToggleDrawer.bind}
                      />
                  </span> */}
          </div>
          {bpmNewCaseUrl !== '' ? (
            <FetchBpmNewCaseIframe src={`${bpmNewCaseUrl}`} />
          ) : (
            <div
              style={{ marginTop: '4rem' }}
              className="gx-d-flex gx-flex-row gx-justify-content-center gx-align-items-center gx-w-100"
            >
              <i
                style={{ color: '#c3c3c3' }}
                className="icon icon-extra-components gx-fs-80"
              />
              <div className="gx-d-flex gx-flex-row gx-justify-content-center gx-align-items-center gx-w-100">
                <span className="gx-text-grey gx-font-weight-bold">
                  آدرسی وجود ندارد
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewCase;
